import { useState, useContext, useEffect } from "react";
import "../../../assests/css/studentdashboard/FeeManagement.css";
import "../../../assests/css/studentdashboard/FeeSubmission.css";
import StudentsideLayout from "../../../layouts/StudentsideLayout";
import axios from "axios";
import { AppContext } from "../../../context/Appcontext";
import { useNavigate } from "react-router-dom";

// ─── Mock Context (replace with your actual context import) ───────────────────
// import { AuthContext } from "../context/AuthContext";
// const { loggedInStudent } = useContext(AuthContext);

const mockLoggedInStudent = {
  fullname: "Ayesha Tariq",
  email: "ayesha.tariq@university.edu",
  program: "BS Computer Science",
  semester: "5th Semester",
  regno: "2021-CS-045",
};

// ─── Fee Invoice Component ────────────────────────────────────────────────────
export default function FeeInvoice() {
  // Destructure from context (replace mock with real context)

  const loggedInStudent = JSON.parse(localStorage.getItem("student"));
  console.log("Student =", loggedInStudent);
  console.log("Programme =", loggedInStudent?.ngprogramme);
  console.log("Department =", loggedInStudent?.ngprogramme?.ngdepartment);
  const { baseUrl, baseUrlForFiles } = useContext(AppContext);

  // ── Fee Model States (populated from API response) ──────────────────────────
  const [ngDepartmentId, setNgDepartmentId] = useState("");
  const [ngSemester, setNgSemester] = useState("");
  const [ngAmount, setNgAmount] = useState("");
  const [ngDueDate, setNgDueDate] = useState("");
  const [ngFeeChallanDetails, setNgFeeChallanDetails] = useState(null);
  const [ngFeeChallanProofs, setNgFeeChallanProofs] = useState([]);
  const navigate = useNavigate();

  // ── Simulate API population (call this with your actual API response) ────────
  // Example usage:
  // const populateFeeData = (apiResponse) => {
  //   setNgDepartmentId(apiResponse.ngdepartment_id);
  //   setNgSemester(apiResponse.semester);
  //   setNgAmount(apiResponse.amount);
  //   setNgDueDate(apiResponse.dueDate);
  // };

  const ngFeeData = {
    ngdepartment_id: ngDepartmentId,
    semester: ngSemester,
    amount: ngAmount,
    dueDate: ngDueDate,
  };

  // ── Format date helper ───────────────────────────────────────────────────────
  const ngFormatDate = (dateStr) => {
    if (!dateStr) return "—";
    const d = new Date(dateStr);
    return d.toLocaleDateString("en-PK", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  };

  // ── Format currency helper ───────────────────────────────────────────────────
  const ngFormatAmount = (amt) => {
    if (!amt) return "PKR —";
    return `PKR ${Number(amt).toLocaleString("en-PK")}`;
  };

  const fetchFeeForStudent = () => {
    const formData = new FormData();
    if (!loggedInStudent?.ngprogramme) {
      console.log("Programme data not found");
      return;
    }

    formData.append(
      "department_id",
      loggedInStudent.ngprogramme.ngdepartment_id
    );
    formData.append("semester", loggedInStudent.semester);
    axios
      .post(`${baseUrl}/student/fee/fetchFeeForStudent`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })

      .then((response) => {
        console.log(response.data);
        console.log("Student Data", loggedInStudent);
        console.log("Programme", loggedInStudent?.ngprogramme);
        setNgFeeChallanDetails(response.data.feeChallan);
        console.log(response.data.feeChallan);
        // if (response.data.success == true) {

        // }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const viewFeeSubmissionProof = () => {

    const formData = new FormData();
    formData.append("ngstudent_id", loggedInStudent.id);

    axios
      .post(`${baseUrl}/student/fee/viewFeeSubmissionProof`, formData, {
        headers: {
          "Content-Type": "multipart-formdata",
        },
      })
      .then((response) => {
        console.log(response.data);
        setNgFeeChallanProofs(response.data.feeChallans);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchFeeForStudent();
    viewFeeSubmissionProof();
  }, []);

  return (
    <StudentsideLayout>
      <div className="ng-page-wrapper">
        {/* ── Background Orbs ─────────────────────────────────────────────────── */}
        <div className="ng-orb ng-orb-1" />
        <div className="ng-orb ng-orb-2" />

        <div className="ng-invoice-card">
          {/* ── Header ──────────────────────────────────────────────────────────── */}
          <div className="ng-invoice-header">
            <div className="ng-header-left">
              <div className="ng-logo-mark">
                <span className="ng-logo-icon">🎓</span>
              </div>
              <div>
                <h1 className="ng-university-name">GGCW STUDENT FEE</h1>
                <p className="ng-university-tagline">
                  Finance & Accounts Division
                </p>
              </div>
            </div>
            <div className="ng-header-right">
              <span className="ng-invoice-badge">FEE INVOICE</span>
              <p className="ng-invoice-id">
                {loggedInStudent?.ngprogramme?.ngdepartment?.deptName || ""}
              </p>
            </div>
          </div>

          <div className="ng-divider" />

          {/* ── Student Info Section ─────────────────────────────────────────────── */}
          <div className="ng-section-label">Student Information</div>
          <div className="ng-student-grid">
            <div className="ng-info-tile">
              <span className="ng-tile-label">Full Name</span>
              <span className="ng-tile-value">{loggedInStudent.fullname}</span>
            </div>
            <div className="ng-info-tile">
              <span className="ng-tile-label">Registration No.</span>
              <span className="ng-tile-value ng-tile-accent">
                {loggedInStudent.regno}
              </span>
            </div>
            <div className="ng-info-tile">
              <span className="ng-tile-label">Email Address</span>
              <span className="ng-tile-value ng-tile-small">
                {loggedInStudent.email}
              </span>
            </div>
            <div className="ng-info-tile">
              <span className="ng-tile-label">Program</span>
              <span className="ng-tile-value">
                {loggedInStudent?.ngprogramme?.progName || ""}
              </span>
            </div>
            <div className="ng-info-tile">
              <span className="ng-tile-label">Student Semester</span>
              <span className="ng-tile-value">{loggedInStudent.semester}</span>
            </div>
          </div>

          {/* ── Fee Details Section ──────────────────────────────────────────────── */}
          <div className="ng-section-label ng-section-label-mt">
            Fee Details
          </div>
          <div className="ng-fee-table">
            <div className="ng-fee-row ng-fee-row-head">
              <span>Description</span>
              <span>Details</span>
            </div>

            <div className="ng-fee-row">
              <span className="ng-fee-label">Department Name</span>
              <span className="ng-fee-val">
                <span className="ng-placeholder">
                  {loggedInStudent?.ngprogramme?.ngdepartment?.deptName || ""}
                </span>
              </span>
            </div>

            <div className="ng-fee-row">
              <span className="ng-fee-label">Fee Semester</span>
              <span className="ng-fee-val">
                <span className="ng-placeholder">
                  {loggedInStudent.semester}
                </span>
              </span>
            </div>

            <div className="ng-fee-row">
              <span className="ng-fee-label">Due Date</span>
              <span className="ng-fee-val">
                <span className="ng-due-badge">
                  {ngFormatDate(ngFeeChallanDetails?.dueDate)}
                </span>
              </span>
            </div>

            <div className="ng-fee-row ng-fee-total-row">
              <span className="ng-fee-label ng-total-label">
                Total Amount Due
              </span>
              <span className="ng-total-amount">
                {ngFormatAmount(ngFeeChallanDetails?.amount)}
              </span>
            </div>
          </div>

          {/* ── Status Bar ──────────────────────────────────────────────────────── */}
          <div className="ng-status-bar">
            <div className="ng-status-dot" />
            <span className="ng-status-text">Pending Payment</span>
            <div className="ng-status-spacer" />
            <span className="ng-generated-text">
              Generated:{" "}
              {ngFeeChallanDetails?.created_at
                ? new Date(ngFeeChallanDetails.created_at).toLocaleDateString(
                  "en-PK",
                  {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  }
                )
                : "—"}
            </span>
          </div>

          {/* ── Action Buttons ───────────────────────────────────────────────────── */}
          <div className="ng-actions">
            <button
              className="ng-btn ng-btn-outline"
              onClick={() => window.print()}
            >
              <span>🖨</span> Print Invoice
            </button>
            {/* <button className="ng-btn ng-btn-primary">

            <span>💳</span> Pay Now
          </button> */}
            <button
              className="ng-btn ng-btn-primary"
              onClick={() =>
                navigate("/fee/submission", {
                  state: { challanid: ngFeeChallanDetails?.id },
                })
              }
            >
              <span>💳</span> Submit Proof
            </button>

            <button
              className="ng-btn ng-btn-outline"
              onClick={() =>
                navigate("/help/support", {
                  state: {
                    request_type: "fee_dispute",
                    reference_id: ngFeeChallanDetails?.id,
                  },
                })
              }
            >
              ⚠ Raise Dispute
            </button>

          </div>

          {/* ── Table (kept but no frontend dummy data) ── */}

          {/* ── Footer ──────────────────────────────────────────────────────────── */}
          <div className="ng-invoice-footer">
            <p>
              This is a system-generated invoice. For queries, contact
              accounts@novgenix.edu.pk
            </p>
          </div>
        </div>
      </div>
      <div className="ng-fs-table-scroll">
        <div className="ng-fs-table-card">
          <div className="ng-fs-table-header">
            <h3 className="ng-fs-table-title">Submission History</h3>
          </div>
        </div>
        <table
          style={{ width: "100%", textAlign: "left" }}
          className="table table-fluid"
        >
          <thead>
            <tr>
              <th>#</th>
              <th>Student</th>
              <th>Challan</th>
              <th>Status</th>
              <th>Challan Image</th>
              <th>Submitted At</th>
            </tr>
          </thead>

          <tbody>
            {ngFeeChallanProofs.map((singleProof) => {
              return (
                <tr>
                  <td>{singleProof.id}</td>
                  <td>{loggedInStudent.fullname}</td>
                  <td>{singleProof?.ngfeechallan.amount}</td>
                  <td>Paid</td>
                  <td><a target="_blank" href={`${baseUrlForFiles}/${singleProof.image}`}><img src={`${baseUrlForFiles}/${singleProof.image}`} style={{ height: 50, width: 50, borderRadius: "100%" }} /></a></td>
                  <td>{new Date(singleProof.created_at).toLocaleDateString()}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </StudentsideLayout>
  );
}